import { render, staticRenderFns } from "./store-order.vue?vue&type=template&id=1bbf8a5a"
import script from "./store-order.vue?vue&type=script&lang=ts"
export * from "./store-order.vue?vue&type=script&lang=ts"
import style0 from "./store-order.vue?vue&type=style&index=0&id=1bbf8a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports